// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.background-switcher {
    position: absolute;
    right: 100%;
    bottom: -1em;
    transform: scaleX(0);
    transform-origin: right;
    transition: transform 0.1s;
    text-align: right;
    display: flex;
    width: calc(var(--buttons-container-width) - 4em);
    flex-wrap: wrap;
    justify-content: flex-end;
    z-index: 1;
}

div.background-switcher-active {
    transform: scaleX(1);
}

div.background-switcher-item {
    background-color: var(--list-bg-color);
    cursor: pointer;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.5);
    display: inline-block;
    margin: 0.5em;
    width: 8em;
    border: 1px solid var(--border-color);
    position: relative;
}

div.background-switcher-item:hover {
    border: 1px solid var(--color-active);
}

div.background-switcher-item:hover div.background-switcher-group,
div.background-switcher-item:focus-within div.background-switcher-group {
    display: block;
}

div.background-switcher-item-active {
    border: 1px solid var(--color-active);
}

div.background-switcher-item-active div.background-switcher-item-title {
    color: var(--color-active);
}

div.background-switcher-item-thumbnail {
    height: 4em;
}

div.background-switcher-item-thumbnail > img {
    width: 100%;
    height: 100%;
}

div.background-switcher-item-title > span:first-child,
div.background-switcher-group > div {
    font-weight: bold;
    font-size: 80%;
    text-align: center;
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0.25em;
}

div.background-switcher-item-title {
    display: flex;
    align-items: center;
}

div.background-switcher-item-title span:first-child {
    flex: 1 1 auto;
}

div.background-switcher-item-title span.icon {
    flex: 0 0 auto;
}

div.background-switcher-group {
    display: none;
    position: absolute;
    bottom: calc(100% + 1px);
    width: 100%;
    background-color: var(--list-bg-color);
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.5);
    clip-path: inset(-8px -8px 0 -8px);
}

div.background-switcher-group-item:hover {
    background-color: var(--list-item-bg-color-hover);
    color: var(--list-item-text-color-hover);
}

div.background-switcher-group-item-active {
    background-color: var(--list-item-bg-color-active);
    color: var(--list-item-text-color-active);
}

div.background-switcher-group-item-active:hover {
    background-color: var(--list-item-bg-color-active-hover);
    color: var(--list-item-text-color-active-hover);
}
`, "",{"version":3,"sources":["webpack://./plugins/style/BackgroundSwitcher.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,0BAA0B;IAC1B,iBAAiB;IACjB,aAAa;IACb,iDAAiD;IACjD,eAAe;IACf,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,sCAAsC;IACtC,eAAe;IACf,0CAA0C;IAC1C,qBAAqB;IACrB,aAAa;IACb,UAAU;IACV,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,wBAAwB;IACxB,WAAW;IACX,sCAAsC;IACtC,0CAA0C;IAC1C,kCAAkC;AACtC;;AAEA;IACI,iDAAiD;IACjD,wCAAwC;AAC5C;;AAEA;IACI,kDAAkD;IAClD,yCAAyC;AAC7C;;AAEA;IACI,wDAAwD;IACxD,+CAA+C;AACnD","sourcesContent":["div.background-switcher {\n    position: absolute;\n    right: 100%;\n    bottom: -1em;\n    transform: scaleX(0);\n    transform-origin: right;\n    transition: transform 0.1s;\n    text-align: right;\n    display: flex;\n    width: calc(var(--buttons-container-width) - 4em);\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    z-index: 1;\n}\n\ndiv.background-switcher-active {\n    transform: scaleX(1);\n}\n\ndiv.background-switcher-item {\n    background-color: var(--list-bg-color);\n    cursor: pointer;\n    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.5);\n    display: inline-block;\n    margin: 0.5em;\n    width: 8em;\n    border: 1px solid var(--border-color);\n    position: relative;\n}\n\ndiv.background-switcher-item:hover {\n    border: 1px solid var(--color-active);\n}\n\ndiv.background-switcher-item:hover div.background-switcher-group,\ndiv.background-switcher-item:focus-within div.background-switcher-group {\n    display: block;\n}\n\ndiv.background-switcher-item-active {\n    border: 1px solid var(--color-active);\n}\n\ndiv.background-switcher-item-active div.background-switcher-item-title {\n    color: var(--color-active);\n}\n\ndiv.background-switcher-item-thumbnail {\n    height: 4em;\n}\n\ndiv.background-switcher-item-thumbnail > img {\n    width: 100%;\n    height: 100%;\n}\n\ndiv.background-switcher-item-title > span:first-child,\ndiv.background-switcher-group > div {\n    font-weight: bold;\n    font-size: 80%;\n    text-align: center;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    padding: 0.25em;\n}\n\ndiv.background-switcher-item-title {\n    display: flex;\n    align-items: center;\n}\n\ndiv.background-switcher-item-title span:first-child {\n    flex: 1 1 auto;\n}\n\ndiv.background-switcher-item-title span.icon {\n    flex: 0 0 auto;\n}\n\ndiv.background-switcher-group {\n    display: none;\n    position: absolute;\n    bottom: calc(100% + 1px);\n    width: 100%;\n    background-color: var(--list-bg-color);\n    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.5);\n    clip-path: inset(-8px -8px 0 -8px);\n}\n\ndiv.background-switcher-group-item:hover {\n    background-color: var(--list-item-bg-color-hover);\n    color: var(--list-item-text-color-hover);\n}\n\ndiv.background-switcher-group-item-active {\n    background-color: var(--list-item-bg-color-active);\n    color: var(--list-item-text-color-active);\n}\n\ndiv.background-switcher-group-item-active:hover {\n    background-color: var(--list-item-bg-color-active-hover);\n    color: var(--list-item-text-color-active-hover);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
